// React import not needed with React 19+ JSX transform
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { FieldConfig } from "../types";

interface SelectFieldProps<T> {
  field: FieldConfig<T>;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  id: string;
  placeholder?: string;
}

export function SelectField<T>({
  field,
  value,
  onChange,
  disabled,
  id,
  placeholder,
}: SelectFieldProps<T>) {
  // Ensure selectOptions is always an array for defensive coding
  const options = Array.isArray(field.selectOptions) ? field.selectOptions : [];

  return (
    <Select value={value ?? ""} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={id} aria-required={field.required || undefined}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option, index) => (
          <SelectItem
            key={option.value ?? `option-${index}`}
            value={String(option.value)}
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
